import Structure from '../modules/structure';

$.fn.filterGroupsCollapsabale = function() {

    var jqAllAffectedContainers = this;

    jqAllAffectedContainers.each(function() {
        const container = $(this);
        const structure = new Structure('filterGroupsCollapsabale', container, {
            heading: ".heading .heading-holder",
            mainContainer: ".filter-contains",
            contentContainer: ".filter-contains .filter-contains-holder"
        }).structure;
        const contentHeight = structure.contentContainer.innerHeight();
        if (container.hasClass('open')) {
            structure.mainContainer.height(contentHeight);
        } else {
            structure.mainContainer.height(0);
        }
        structure.heading.on('click', function(e){
            e.preventDefault();
            if (container.hasClass('open')) {
                structure.mainContainer.height(0);
                container.removeClass('open');
            } else {
                structure.mainContainer.height(contentHeight);
                container.addClass('open');
            }
        });
    });

    return this;
};

document.fonts.ready.then(function () {
    $('.collapsabale-filter-group-js').filterGroupsCollapsabale();
});
